// 外部价格主数据API
export default {
  // 产品父类
  LIST_PRODUCT: '/maindata/product/listProduct',
  // 产品子类
  GET_PRODUCT_DETAIL: '/maindata/product/getProductDetail',
  // 全部产品
  LIST_PRODUCT_ALL: '/maindata/productDetail/listProductAll',
  // 字典表查询
  DICT_LIST: '/maindata/dictData/listDataDictByDataType',
  // 获取部门
  DEPARTMENT_LIST: '/maindata/department/listDepartmentByCompanyCode',
  // 获取外部价格列表
  LIST_EXTERNAL_PRICE: '/maindata/externalPrice/listExternalPrice',
  // 获取均价
  GET_PRICE_VALUE: '/maindata/externalPrice/getPriceValue',
  // 获取外部价格详情
  GET_EXTERNAL_PRICE: '/maindata/externalPrice/getExternalPrice',
  // 获取外部价格详情
  GET_EXTERNAL_PRICE_LIST: '/maindata/externalPrice/getExternalPriceList',
  // 保存
  SAVE_OR_UPDATE_PRICE: '/maindata/externalPrice/saveOrUpdatePrice',
  // 删除
  DELETE_EXTERNAL_PRICE: '/maindata/externalPrice/deleteExternalPrice',
  // 导出
  EXPORT_EXTERNAL_PRICE: '/maindata/externalPrice/exportExternalPrice',
  // 币种数据(币种管理)
  LIST_CURRENCY: '/maindata/currency/listCurrency',
  // 获取人员信息
  GET_LIST_PERSON: '/maindata/person/listPerson',
  //导入
  IMPORT_API: '/maindata/externalPrice/importExternalPriceExcel',
};
